import "../stylesheets/admin"

global.toastr = require("toastr")
require("packs/choices/init")
